import TopPageLoader from './top-page-loader';

export default TopPageLoader;
